var map = {
	"./bh-ico-active.svg": 1777,
	"./bh-ico.svg": 1778,
	"./bonus-ico-active.svg": 1779,
	"./bonus-ico.svg": 1780,
	"./deposit-ico.svg": 1781,
	"./deposit-ico.webp": 1782,
	"./edit-icon.svg": 1783,
	"./fb-ico.svg": 1784,
	"./instant-rebate-ico-active.svg": 1785,
	"./instant-rebate-ico.svg": 1786,
	"./mall-ico-active.svg": 1787,
	"./mall-ico.svg": 1788,
	"./msg-ico-active.svg": 1789,
	"./msg-ico.svg": 1790,
	"./pi-ico-active.svg": 1791,
	"./pi-ico.svg": 1792,
	"./rf-ico-active.svg": 1793,
	"./rf-ico.svg": 1794,
	"./rh-ico-active.svg": 1795,
	"./rh-ico.svg": 1796,
	"./th-ico-active.svg": 1797,
	"./th-ico.svg": 1798,
	"./vip-ico-active.svg": 1799,
	"./vip-ico.svg": 1800,
	"./withdrawal-ico.svg": 1801,
	"./withdrawal-ico.webp": 1802,
	"./wl-ico-active.svg": 1803,
	"./wl-ico.svg": 1804
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 472;